const bjpCandidatesDesc: string[] = [
  `Number one candidate`,
  `Number two candidate`,
  `Number three candidate`,
]

export default bjpCandidatesDesc
